export const countriesData = [
  {
    key: "1",
    REVIEW: "United States",
    IMAGE: "us.png",
    CREATEDDATE: "US",
    STATUS: "Active",
  },
  {
    key: "2",
    REVIEW: "Canada",
    IMAGE: "ca.png",
    CREATEDDATE: "CA",
    STATUS: "Inactive",
  },
  {
    key: "3",
    REVIEW: "United Kingdom",
    IMAGE: "uk.png",
    CREATEDDATE: "UK",
    STATUS: "Active",
  },
  {
    key: "4",
    REVIEW: "Germany",
    IMAGE: "de.png",
    CREATEDDATE: "DE",
    STATUS: "Active",
  },
  {
    key: "5",
    REVIEW: "France",
    IMAGE: "fr.png",
    CREATEDDATE: "FR",
    STATUS: "Active",
  },
  {
    key: "6",
    REVIEW: "Argentina",
    IMAGE: "ar.png",
    CREATEDDATE: "AR",
    STATUS: "Inactive",
  },
  {
    key: "7",
    REVIEW: "India",
    IMAGE: "in.png",
    CREATEDDATE: "IN",
    STATUS: "Inactive",
  },
  {
    key: "8",
    REVIEW: "Italy",
    IMAGE: "it.png",
    CREATEDDATE: "IT",
    STATUS: "Active",
  },
  {
    key: "9",
    REVIEW: "New Zealand",
    IMAGE: "nz.png",
    CREATEDDATE: "IT",
    STATUS: "Active",
  },
  {
    key: "10",
    REVIEW: "Australia",
    IMAGE: "au.png",
    CREATEDDATE: "AU",
    STATUS: "Active",
  },
];
